import React from 'react';
import '../../../Styles/components/PullToRefreshIndicator.scss';

interface PullToRefreshIndicatorProps {
    isPulling: boolean;
    isRefreshing: boolean;
    pullDistance: number;
    progress: number;
}

/**
 * Visual indicator for Pull-to-Refresh
 * Shows spinner animation when pulling/refreshing
 */
export const PullToRefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
    isPulling,
    isRefreshing,
    pullDistance,
    progress,
}) => {
    if (!isPulling && !isRefreshing) return null;

    return (
        <div 
            className="pull-to-refresh-indicator"
            style={{
                transform: `translate(-50%, ${Math.min(pullDistance + 20, 100)}px)`,
                opacity: Math.min(progress * 2, 1),
                scale: Math.min(0.8 + (progress * 0.2), 1),
            }}
        >
            <div 
                className={`pull-to-refresh-indicator__spinner ${isRefreshing ? 'pull-to-refresh-indicator__spinner--refreshing' : ''}`}
                style={{
                    transform: isRefreshing ? 'none' : `rotate(${progress * 360}deg)`,
                }}
            >
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <circle
                        cx="16"
                        cy="16"
                        r="12"
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeDasharray="75"
                        strokeDashoffset={isRefreshing ? 0 : (75 - (75 * progress))}
                    />
                </svg>
            </div>
            {isRefreshing && (
                <div className="pull-to-refresh-indicator__text">
                    Aktualisiere...
                </div>
            )}
        </div>
    );
};
